import React, { PropTypes, Component } from 'react'
import classNames from 'classnames'
import styles from './styles'

export default class RadioSelect extends Component {
  static propTypes = {
    title: PropTypes.string,
    map: PropTypes.object.isRequired,
    selectedKey: PropTypes.string,
    onSelect: PropTypes.func,
  };

  static defaultProps = {
    selectedIndex: null,
  };

  constructor (props) {
    super(props)
    this.genOnSelect = key => () => this.props.onSelect(key)
  }

  render () {
    const { title, map, selectedKey } = this.props
    const keys = Object.keys(map)
    return (
      <div className={styles.radioSelect}>
        {title ? <div className={styles.radioTitle}>{`${title}： `}</div> : null}
        <div
          className={classNames(
            styles.radioItem,
            styles.radioFirst,
            { [styles.radioSelected]: selectedKey === null })}
          onClick={this.genOnSelect(null)}
        >全部</div>
        {keys.map((key, i) =>
          <div
            key={key}
            className={classNames(
              styles.radioItem,
              { [styles.radioLast]: i === keys.length - 1,
                [styles.radioSelected]: selectedKey === key })}
            onClick={this.genOnSelect(key)}
          >{map[key]}</div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataTable/radioSelect.jsx